import { getDistanceSurcharges, IDistanceSurcharge } from "@/api/settings";
import { CreateDistanceSurchargeModal } from "@/components/dashboard/distance-surcharge/CreateDistanceSurchargeModal";
import { DistanceSurchargeDeleteIcon } from "@/components/dashboard/distance-surcharge/DeleteDistanceSurcharge";
import { UpdateDistanceSurchargeModal } from "@/components/dashboard/distance-surcharge/UpdateDistanceSurchargeModal";
import { Edit } from "@mui/icons-material";
import {
    Box,
    Card,
    Divider,
    IconButton,
    Skeleton,
    Stack,
    Typography,
} from "@mui/material";
import { FormButton } from "@rhf-kit/mui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export const DistanceSurchargeForm = () => {
    const { isPending, isError, data, refetch } = useQuery({
        queryKey: ["admin-distance-surcharges"],
        queryFn: getDistanceSurcharges,
    });

    const [create, setCreate] = useState<boolean>(false);
    const [edit, setEdit] = useState<boolean>(false);
    const [selected, setSelected] = useState<IDistanceSurcharge>();

    if (isPending || !data) {
        return <Skeleton height={200} />;
    }

    if (isError) {
        throw new Error("Could not get distance surcharges");
    }

    return (
        <Card sx={{ borderRadius: "10px", p: 3 }}>
            <Typography
                variant="h6"
                fontWeight={600}
                textAlign="left"
                gutterBottom
            >
                Distance Surcharges
            </Typography>
            <Stack spacing={2} my={2}>
                {data.items.length === 0 && (
                    <Typography>No Distance Surcharges</Typography>
                )}
                {data.items.map((surcharge) => (
                    <div key={`surcharge-${surcharge.id}`}>
                        <Stack
                            direction={"row"}
                            sx={{ justifyContent: "space-between" }}
                            display="flex"
                            alignItems="center"
                        >
                            <Typography>
                                {surcharge.minimum_miles}+ miles (+ $
                                {(surcharge.surcharge / 100).toFixed(2)})
                            </Typography>
                            <Box>
                                <IconButton
                                    onClick={() => {
                                        setSelected(surcharge);
                                        setEdit(true);
                                    }}
                                >
                                    <Edit />
                                </IconButton>
                                <DistanceSurchargeDeleteIcon
                                    distanceSurcharge={surcharge}
                                />
                            </Box>
                        </Stack>
                        <Divider />
                    </div>
                ))}
            </Stack>
            <FormButton
                onClick={() => setCreate(true)}
                variant="contained"
                loading={false}
                sx={{
                    backgroundColor: "#40ABBA",
                    ":hover": { backgroundColor: "#2a6574" },
                }}
            >
                New Distance Surcharge
            </FormButton>
            <CreateDistanceSurchargeModal
                open={create}
                setOpen={setCreate}
                mutateDistanceSurcharges={refetch}
            />
            <UpdateDistanceSurchargeModal
                open={edit}
                distanceSurcharge={selected}
                setSelected={setSelected}
                setOpen={setEdit}
                mutateDistanceSurcharges={refetch}
            />
        </Card>
    );
};
